import { Checkbox } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import React from "react";

const GENERIC_TOOLS = [
  {
    id: "reset_conversation",
    labelKey: "cx-agent-setup.tool-reset-conversation",
    defaultLabel: "Reset Conversation",
  },
  {
    id: "send_image_to_user",
    labelKey: "cx-agent-setup.tool-send-image",
    defaultLabel: "Send Image to User",
  },
  {
    id: "human_handover",
    labelKey: "cx-agent-setup.tool-human-handover",
    defaultLabel: "Human Handover",
  },
] as const;

export const GenericToolsSection: React.FC<{
  selected: string[];
  onChange: (tools: string[]) => void;
}> = ({ selected, onChange }) => {
  const { t } = useTranslations();

  const toggle = (toolId: string) => {
    if (selected.includes(toolId)) {
      onChange(selected.filter((id) => id !== toolId));
    } else {
      onChange([...selected, toolId]);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      {GENERIC_TOOLS.map((tool) => (
        <Checkbox
          key={tool.id}
          isChecked={selected.includes(tool.id)}
          onChange={() => toggle(tool.id)}
          label={t({ id: tool.labelKey, defaultMessage: tool.defaultLabel })}
        />
      ))}
    </div>
  );
};
